import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0acd29a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Recupero password")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Chiudi")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Invia ")

import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonButton,
  IonLabel,
  IonInput,
  IonFooter,
  modalController,
  toastController,
} from '@ionic/vue';
import {ref} from 'vue';
import axios from "axios";

    
export default /*#__PURE__*/_defineComponent({
  emits: [
        'dismiss'
    ],
  setup(__props, { emit: emits }) {



    const email = ref(null)

    async function openToastOptions(data, color = 'success') {
      const toast = await toastController.create({
        color: color,
        duration: 2000,
        message: data,
      });
      await toast.present();
    }

    async function dismissModal() {
      const modal = await modalController
      return modal.dismiss();
    }

    const forgotPassword = () => {
      if(email.value) {
        axios.post(`${process.env.VUE_APP_APIURL}auth/forgotpassword`, {
          email: email.value,
        })
            .then(() => {
              openToastOptions('Email di recupero inviata!', 'success')
              dismissModal()
            })
            .catch(error => {
              if (error.response.data.message) {
                openToastOptions(error.response.data.message, 'danger')
              } else {
                Object.values(error.response.data)
                    .forEach((message: any) => {
                      openToastOptions(message, 'danger')
                    })
              }
            })
      } else {
        openToastOptions('Inserisci la mail', 'warning')
      }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: dismissModal }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createVNode(_unref(IonLabel), { position: "stacked" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_unref(IonInput), {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            type: "email"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonButton), {
          onClick: forgotPassword,
          expand: "block",
          "ion-button": "",
          block: "",
          class: "btn button",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})